/*
Next steps:
	- Move all flux stores into this main store
	- Refactor stores to be reducers
*/
import { compose, createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { dashApiInterceptorSetup } from '../support/dash_api';
import { serverReduxSetup } from '../support/server';

import AccessControl from './AccessControlReducer';
import AdLinks from './AdLinksReducer';
import AdPartner from './AdPartnerReducer';
import AgencyRelationshipReducer from './AgencyRelationshipReducer';
import AppReducer from '../../common/reducers/AppReducer';
import AuthServiceReducer from './AuthServiceReducer';
import BillingAccount from './BillingAccountReducer';
import Cnames from './CnamesReducer';
import DataIntegrations from './DataIntegrationsReducer';
import DomainLinks from './DomainLinksReducer';
import EmailOnboarding from './EmailOnboarding';
import Facebook from './FacebookReducer';
import FlipperUpdates from './FlipperReducer';
import Google from './GoogleReducer';
import Invoices from './InvoicesReducer';
import Journey from './JourneyReducer';
import Deepview from './DeepviewReducer';
import Schedule from './ScheduleReducer';
import LinkCreator from './LinkCreatorReducer';
import CsvExport from './CsvExport';
import TuneCustomExport from './CustomExportReducer/TuneCustomExportReducer';
import BranchCustomExport from './CustomExportReducer/BranchCustomExportReducer';
import Org from '../../common/reducers/OrgReducer';
import Payments from './PaymentsReducer';
import PaymentMethods from './PaymentMethodsReducer';
import PbaLiveview from './PbaLiveviewReducer';
import ProductFeeds from './ProductFeedReducer';
import SDKInfo from './SDKInfoReducer';
import SSO from './SsoReducer';
import Subscriptions from './SubscriptionsReducer';
import Team from './TeamReducer';
import ThirdPartyGlobalSettings from './ThirdPartyGlobalSettingsReducer';
import ThirdPartyProviderConfig from './ThirdPartyProviderConfigReducer';
import Webhooks from './WebhooksReducer';
import AppleSearchAds from './AppleSearchAdsReducer';
import Snap from './SnapReducer';
import Twitter from './TwitterReducer';
import Fraud from './FraudReducer';
import Activity from './ActivityReducer';
import LogoutModal from './LogoutModalReducer';
import PersonaServiceReducer from './PersonaServiceReducer'; // rename to reducer
import WhitelistedDeviceOrmReducer from './WhitelistedDeviceOrmReducer';
import DiscoAds from './DiscoAdsReducer';
import Audience from './AudienceReducer';
import SKAdnetwork from './SKAdnetworkReducer';
import UserEntityTerms from '../../common/reducers/UserEntityTermsReducer';

// TODO temporary, reducers used by other projects should be moved to /common
export const reducers = {
  accessControl: AccessControl,
  ad_links: AdLinks,
  ad_partner: AdPartner,
  agencyRelationship: AgencyRelationshipReducer,
  app: AppReducer,
  auth_service: AuthServiceReducer,
  billing_account: BillingAccount,
  cnames: Cnames,
  csvExport: CsvExport,
  branchCustomExport: BranchCustomExport,
  tuneCustomExport: TuneCustomExport,
  dataIntegrations: DataIntegrations,
  deepview: Deepview,
  domainLinks: DomainLinks,
  emailOnboarding: EmailOnboarding,
  facebook: Facebook,
  apple_search_ads: AppleSearchAds,
  flipper_updates: FlipperUpdates,
  google: Google,
  health_checks: require('./HealthCheckReducer').default,
  invoices: Invoices,
  journey: Journey,
  linkCreator: LinkCreator,
  org: Org,
  payments: Payments,
  payment_methods: PaymentMethods,
  pba_liveview: PbaLiveview,
  persona_service: PersonaServiceReducer,
  product_feeds: ProductFeeds,
  schedule: Schedule,
  sdk_info: SDKInfo,
  shareable: require('../../common/reducers/ShareableReducer').default,
  snap: Snap,
  sso: SSO,
  subscriptions: Subscriptions,
  team: Team,
  third_party_global_settings: ThirdPartyGlobalSettings,
  third_party_provider_config: ThirdPartyProviderConfig,
  twitter: Twitter,
  webhook: Webhooks,
  whitelist_devices: WhitelistedDeviceOrmReducer,
  fraud: Fraud,
  activity: Activity,
  druid: require('../../common/reducers/DruidReducer').default,
  ob_link: require('../../common/reducers/OnboardingLinkReducer').default,
  quick_links: require('./QuickLinksReducer').default,
  user: require('../../common/reducers/UserReducer').default,
  logout_modal: LogoutModal,
  feedback: require('./FeedbackReducer').default,
  disco_ads: DiscoAds,
  audience: Audience,
  skadnetwork: SKAdnetwork,
  userEntityTerms: UserEntityTerms
};

const app = combineReducers(reducers);

const composeEnhancers =
  process.env.NODE_ENV != 'production' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        name: 'Dashboard'
      })
    : compose;

const getMiddlewares = () => {
  const middlewares = [thunk];
  return middlewares;
};

const enhancer = composeEnhancers(applyMiddleware(...getMiddlewares()));

const store = createStore(app, enhancer);

dashApiInterceptorSetup(store);
serverReduxSetup(store);

export default store;
